import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Alert,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { useAppDispatch, useAppSelector, fetchServices } from "../store";
import { ServiceGrid } from "../components/services";
import { Service } from "../types";

const ServicesPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { services, isLoading, error } = useAppSelector(
    (state) => state.services,
  );
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    dispatch(fetchServices({ page: 0, size: 50 }));
  }, [dispatch]);

  // Filter services by search query
  const filteredServices: Service[] = searchQuery
    ? services.filter(
        (s) =>
          s.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          s.description?.toLowerCase().includes(searchQuery.toLowerCase()),
      )
    : services;

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 600,
          }}
        >
          Available Services
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            mb: 3,
          }}
        >
          Browse our catalog of Docker services. Select a service to get
          started.
        </Typography>

        <TextField
          placeholder="Search services..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          size="small"
          sx={{
            width: { xs: "100%", sm: 300 },
            "& .MuiOutlinedInput-root": {
              bgcolor: "background.paper",
            },
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            },
          }}
        />
      </Box>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      <ServiceGrid
        services={filteredServices}
        isLoading={isLoading}
        emptyMessage={
          searchQuery
            ? "No services match your search"
            : "No services available"
        }
      />
      {!isLoading && filteredServices.length > 0 && (
        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
            }}
          >
            Showing {filteredServices.length} of {services.length} services
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ServicesPage;
